import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
//
//
//
//
//
//
//
//
//
//
//
import AnimatedForeground from '~/components/molecules/Global/AnimatedForeground.vue';
export default {
  name: 'AnimatedForegroundBlock',
  components: {
    AnimatedForeground: AnimatedForeground
  },
  props: {
    payload: {
      type: Object,
      required: true
    }
  },
  computed: {
    currentPayload: function currentPayload() {
      return {
        color: this.payload.primary.color,
        svgOne: this.payload.primary.svg_one || 'star',
        svgOneSize: this.payload.primary.svg_one_size,
        svgTwo: this.payload.primary.svg_two,
        svgTwoSize: this.payload.primary.svg_two_size,
        svgThree: this.payload.primary.svg_three,
        svgThreeSize: this.payload.primary.svg_three_size
      };
    }
  }
};